import { arrayContains } from 'utils/arrayContains';
import { SEND_INSURANCE_COOPERATION_OAUTH_TOKEN_FAILURE } from 'redux/actions/users/Insurance';

export const isInsuranceCooperationOAuthFailed = (state) =>
  arrayContains(state.entities.users.failedRequests, [SEND_INSURANCE_COOPERATION_OAUTH_TOKEN_FAILURE]);
